import { DIGITAL_PRODUCTS } from '../models/digitalProducts.js';

/**
 * Crisis Type to Digital Product Resource Mapping
 * Maps crisis types to relevant CrisisCompass digital resources
 */
export const CRISIS_TYPE_RESOURCE_MAPPING = {
  'Active Threat': [
    DIGITAL_PRODUCTS.ACTIVE_THREAT.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id
  ],
  'Cyber Incident': [
    DIGITAL_PRODUCTS.CYBER_INCIDENT.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id
  ],
  'Medical Emergency': [
    DIGITAL_PRODUCTS.MEDICAL_EMERGENCY.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id
  ],
  'Fire': [
    DIGITAL_PRODUCTS.FIRE.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id
  ],
  'Flood': [
    DIGITAL_PRODUCTS.FLOOD.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id,
    DIGITAL_PRODUCTS.BUSINESS_CONTINUITY_PLAN.id
  ],
  'Earthquake': [
    DIGITAL_PRODUCTS.EARTHQUAKE.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id,
    DIGITAL_PRODUCTS.BUSINESS_CONTINUITY_PLAN.id
  ],
  'Cyclone/Severe Weather': [
    DIGITAL_PRODUCTS.CYCLONE.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id,
    DIGITAL_PRODUCTS.BUSINESS_CONTINUITY_PLAN.id
  ],
  'Suspicious Item/Bomb Threat': [
    DIGITAL_PRODUCTS.SUSPICIOUS_ITEM_BOMB_THREAT.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id
  ],
  'Kidnap for Ransom': [
    DIGITAL_PRODUCTS.KIDNAP_KRE.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.HIGH_RISK_TRAVEL_PLAN.id
  ],
  'Extortion': [
    DIGITAL_PRODUCTS.KIDNAP_KRE.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id
  ],
  'Meeting/Event Incident': [
    DIGITAL_PRODUCTS.MEETING_EVENT_INCIDENT.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id
  ],
  'Critical Incident': [
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.BUSINESS_CONTINUITY_PLAN.id
  ],
  'Aggressive Customer': [
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id
  ],
  'Threats Against Executive': [
    DIGITAL_PRODUCTS.ACTIVE_THREAT.id,
    DIGITAL_PRODUCTS.HIGH_RISK_TRAVEL_PLAN.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id
  ],
  'Protest/Civil Unrest': [
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id,
    DIGITAL_PRODUCTS.EVACUATION_PREPAREDNESS.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id
  ],
  'Reputational Incident': [
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id
  ],
  'Workplace Injury': [
    DIGITAL_PRODUCTS.MEDICAL_EMERGENCY.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id
  ],
  'Data Breach': [
    DIGITAL_PRODUCTS.CYBER_INCIDENT.id,
    DIGITAL_PRODUCTS.CRISIS_COMMUNICATION_PLAN.id,
    DIGITAL_PRODUCTS.CRITICAL_INCIDENT.id
  ],
  'Exercise': [
    DIGITAL_PRODUCTS.CRISIS_PLAN.id,
    DIGITAL_PRODUCTS.BUSINESS_CONTINUITY_PLAN.id,
    DIGITAL_PRODUCTS.POST_INCIDENT_REVIEW_TEMPLATE.id
  ]
};

/**
 * Get available resources for a specific crisis type
 * @param {string} crisisType - The crisis type from incident creation
 * @param {Array} organizationDigitalProducts - Array of product IDs the org has access to
 * @returns {Array} Array of resource objects with id and name
 */
export const getAvailableResourcesForCrisisType = (crisisType, organizationDigitalProducts = []) => {
  console.log('🎯 getAvailableResourcesForCrisisType called with:');
  console.log('  - crisisType:', crisisType);
  console.log('  - organizationDigitalProducts:', organizationDigitalProducts);
  
  // Get mapped resource IDs for the crisis type
  const mappedResourceIds = CRISIS_TYPE_RESOURCE_MAPPING[crisisType] || [];
  console.log('  - mappedResourceIds for crisis type:', mappedResourceIds);
  
  // Filter to only include products the organization has access to
  const availableResourceIds = mappedResourceIds.filter(resourceId => 
    organizationDigitalProducts.includes(resourceId)
  );
  console.log('  - availableResourceIds after filtering:', availableResourceIds);
  
  // Convert to resource objects with id and name
  const availableResources = availableResourceIds.map(resourceId => {
    const product = Object.values(DIGITAL_PRODUCTS).find(p => p.id === resourceId);
    return product ? { id: product.id, name: product.name } : null;
  }).filter(Boolean);
  
  console.log('  - final availableResources:', availableResources);
  return availableResources;
}; 